import React, { useEffect, useMemo, useState } from "react";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import {
  AdvSeparator,
  Backdrop,
  Button,
  CopyToClipboard,
  Drawer,
  DualIcon,
  InfoTextAdv,
  LogoLoader,
  Modal,
  PageHeader,
  showToast,
  PageTitle,
  SmartTooltip,
  StatusTags,
  NewTab,
  DocumentViewerATS,
} from "../../../../../components";
import Resume from "../AllApplicantsViewTabs/Resume";
import PersonalDetails from "../AllApplicantsViewTabs/PersonalDetails";
import JobApplied from "../AllApplicantsViewTabs/JobApplied";
import Notes from "../AllApplicantsViewTabs/Notes";
import Skills from "../AllApplicantsViewTabs/Skills";
import WorkExperience from "../AllApplicantsViewTabs/WorkExperience";
import EmailMerges from "../AllApplicantsViewTabs/EmailMerges";
import ApplicantEmailModal from "./ApplicantDetailsModals/ApplicantEmailModal";
import ApplicantNotesModal from "./ApplicantDetailsModals/ApplicantNotesModal";
import ApplicantSubmitJobModal from "./ApplicantDetailsModals/ApplicantSubmitJobModal";
import { Link } from "react-router-dom";
import { getApplicant } from "../../../../../redux/slices/recruitmentSourcing/SourcingApi";
import {
  addCandidateNotes,
} from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { getCandidateResumeFromDB } from "../../../../../redux/slices/internalDbES/internalDbESApi";
import { useDispatch, useSelector } from "react-redux";
import { updateApplicantNotes, updateApplicantWithNotes } from "../../../../../redux/slices/recruitmentSourcing/SourcingSlice";
import { updateAllSourceNotes } from "../../../../../redux/slices/internalDbES/internalDbESlice";
import { updateAllOtherSourceNotes } from "../../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { formatPhoneNumberLength, formatWords2 } from "../../../../../utils/stringUtils";
import { hasContent, isFileTypeMissingFromUrl } from "../../../../../utils/common";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";

const ApplicantsDetailsDrawer = ({
  isOpen,
  onClose,
  showResumeButton = false,
  applicantId,
  filteredApplicantData,
  keywords,
  source,
  page, // for Allapplicants page notes fetch only
  limit // for Allapplicants page notes fetch only
}) => {
  //  console.log(applicantId)
  const { user } = useSelector((state) => state.auth);
  const [applicantData, setApplicantData] = useState(null);
  const [emailModal, setEmailModal] = useState(false);
  const [notesModal, setNotesModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [awsUrl, setAwsUrl] = useState("");
  const [awsHtmlResume, setAwsHtmlResume] = useState("");
  const [submitJobModal, setSubmitJobModal] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [notes, setCandidateNotes] = useState("");
  const [notesRefreshKey, setNotesRefreshKey] = useState(0);
  const [awsurlloading, setawsurlLoading] = useState(false)
  const { loading } = useSelector((state) => state.internalDbES);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  //console.log(keywords)
  //console.log(applicantData)
  // console.log(applicantId)

//   useEffect(() => {
//   if (isOpen) {
//     setActiveTab(0); 
//   }
// }, [isOpen, applicantId]);

  const viewMenus = [
    {
      title: "Resume",
      page: (
        <Resume
          isOpen={isOpen}
          showResumeButton={showResumeButton}
          keywords={keywords}
          candidate={applicantData ? applicantData : filteredApplicantData}
          source={
            applicantData
              ? applicantData?.source
              : filteredApplicantData?.source
          }
          onClose={onClose}
        />
      ),
      //   page: <Resume applicant={selectedApplicant} />,
      type: "main",
    },

    {
      title: "Personal Details",
      //   page: <PersonalDetails applicant={selectedApplicant} />,
      page: (
        <PersonalDetails applicant={applicantData || filteredApplicantData} />
      ),
      type: "main",
    },
    {
      title: "Jobs Submitted",
      page: <JobApplied data={applicantData}/>,
      type: "main",
    },
    {
      title: "Notes",
      //   page: <Notes applicant={selectedApplicant} />,
      page: <Notes applicantId={applicantData?.uiid} refreshKey={notesRefreshKey} openNotesModal={() => setNotesModal(true)} source={source} />,
      type: "main",
    },
    {
      title: "Skills",
      page: <Skills applicant={applicantData} />,
      type: "main",
    },
    {
      title: "Work Experience",
      page: <WorkExperience applicant={applicantData} />,
      type: "main",
    },
    {
      title: "Mail Merge",
      page: <EmailMerges applicantId={applicantData?.uiid} refreshKey={notesRefreshKey} />,
      type: "main",
    },
  ];
  const htmlFormat = source === 1
    ? applicantData?.htmlResume || filteredApplicantData?.htmlResume || "Resume not available"
    : applicantData?.resumes?.at(-1)?.files?.at(-1)?.html || filteredApplicantData?.resumes?.at(-1)?.files?.at(-1)?.html || "Resume not available";
  //  console.log(applicantData)  
  const data = {
    Mobile: applicantData?.mobile?.primary?.number
      ? `${applicantData?.mobile?.primary?.code} ${formatPhoneNumberLength(applicantData?.mobile?.primary?.code,applicantData?.mobile?.primary?.number)}`
      : "N/A",
    "Job Title":
      formatWords2(applicantData?.jobTitle || filteredApplicantData?.jobTitle || "—"),
    Location:
      formatWords2(applicantData?.location?.city || filteredApplicantData?.location || "—"),
    "Work Authorization": formatWords2(applicantData?.workAuth || filteredApplicantData?.workAuth || "—"),
    "Experience (Years)":
      applicantData?.exp?.year != null && applicantData?.exp?.mon != null
        ? `${applicantData?.exp?.year}.${applicantData?.exp?.mon}`
        : filteredApplicantData?.experience || "—",

    Email: applicantData?.email?.primary?.email || "—",
  };
  console.log("data",data)
  const applicantIdForNav = applicantData?.uiid ?? filteredApplicantData?.uiid ?? null;
  const handleClose = () => {
    setApplicantData(null);
    setActiveTab(0);
    onClose();
  };
  //console.log(filteredApplicantData)

  const fetchApplicant = async () => {
    if (!isOpen) return;
    if (!applicantId) {
      setApplicantData(null);
      return;
    }
    try {
      let res;
      if (!isNaN(applicantId)) {
        res = await getApplicant({
          fil: JSON.stringify({
            uiid: { type: "NONE", value: applicantId },
          }),
          coll: "Candidate",
          ref: "Resume",
          extret: "uiid firstName",
        });
      } else {
        res = await getCandidateResumeFromDB({
          coll: "Candidate",
          fil: { "resumeIds.id": { type: "NONE", value: applicantId } },
          ref: "Resume",
          extret: "uiid firstName",
        });
      }
      if (res?.data?.data) {
        setApplicantData(res?.data?.data);
      } else {
        //showToast("No applicant details found", "warning");
      }
    } catch (err) {
      console.error(err);
      showToast("Failed to fetch applicant details", "error");
    }
  };
  useEffect(() => {
    fetchApplicant();
  }, [applicantId, isOpen]);
  // if (loading) {
  //   return (
  //     <Drawer isOpen={isOpen} onClose={onClose} width="w-5xl" title="">
  //       <div className="p-10 text-center text-gray-500">Loading applicant details...</div>
  //     </Drawer>
  //   );
  // }

  //download
  // const resumeLink = applicantData?.resumes?.[0]?.files?.[0]?.key ?? "";
  const resumeLink = applicantData?.resumes?.at(-1)?.files?.at(-1)?.key ?? "";
  const resumeName =
    `${applicantData?.firstName} ${applicantData?.middleName} ${applicantData?.lastName}` ?? "resume";
  const resumePathName =
    applicantData?.resumes?.at(-1)?.files?.at(-1)?.name ?? "Resume.docx";
  const resumeId = applicantData?.resumeIds?.[0] ?? "";

  const handleDownloadResume = async (response) => {
    try {
      if (typeof response === "string" && response.startsWith("http")) {
        const link = document.createElement("a");
        link.href = response;
        link.download = resumeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        showToast("Download successful.", "success", 2000);
        return; 
      }
      let blob = response;
      if (response instanceof ArrayBuffer) blob = new Blob([response]);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = resumeName || "resume.docx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
      showToast("Download successful.", "success", 2000);
    } catch (error) {
      showToast("Download unsuccessful.", "error", 2000);
      console.error(
        "Error triggering download:",
        error && error.message ? error.message : error
      );
    }
  };

  function extractS3Key(url) {
    return url.replace(/^https?:\/\/[^/]+\//, "");
  }

  const getCandidateResume = async () => {
    const fileExtension = resumePathName?.split('.').pop();
    const query = new URLSearchParams({
      key: extractS3Key(resumeLink),
      fileName: `${resumeName}.${fileExtension}`,
      coll: "Candidate",
    }).toString();

    const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;
    try {
       const response= await axiosRequest({method:"GET",url})
      const data = response?.data?.data?.url ||"";
      if(data){
        const fileFormateWorng =await  isFileTypeMissingFromUrl(data);
        if(fileFormateWorng){
          showToast("File format is not supported", "warning");
          return;
        }
      }
      handleDownloadResume(data);
    } catch (err) {
      showToast("File was not downloaded.", "error");
      console.error("Error fetching data:", err);
    }
  };

  //view Resume
  const viewResume = async () => {
    const query = new URLSearchParams({
      key: extractS3Key(resumeLink),
      // fileName: resumePathName,
      coll: "Candidate",
      html:true
    }).toString();

    const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;
    setawsurlLoading(true)
    try {
      setAwsUrl("");
      setAwsHtmlResume("")
      const response= await axiosRequest({method:"GET",url})
      const s3Key = response?.data?.data?.url ||"";
      setAwsUrl(s3Key);
      setAwsHtmlResume(response?.data?.data?.htmlContent ||"");
      setawsurlLoading(false)
    } catch (err) {
      setawsurlLoading(false)
    } finally {
      setawsurlLoading(false)
    }
  };

  //Add notes

  const notesTabIndex = useMemo(
    () => viewMenus.findIndex((tab) => tab.title === "Notes"),
    [viewMenus]
  );
  const handleAddNotes = async (jobPost, priority) => {
    if (!notes?.trim()) {
      showToast("Please Enter Notes", "error", 2000);
      return;
    }
    // let callApi = false
    try {
      const res = await addCandidateNotes({
        coll: "Note",
        postActions: ["updateSource"],
        payload: {
          addedBy: user?.data?.uiid,
          candidateId: applicantData?.uiid,
          note: notes,
          source: 2,
          ...(jobPost != null && { jobPostId: jobPost }),
          ...(priority != null && { priority })
        },
      });
      if (res?.data) {
        setNotesModal(false);
        showToast("Notes added successfully.", "success", 2000);
        setCandidateNotes("");
        const data = res?.data?.data || {}
        dispatch(updateAllSourceNotes({ applicantId: data.candidateId, newNoteUiid: data.uiid,uiid:data.uiid,note: data?.note,addedBy: data?.addedBy,addedOn: data?.addedOn }))
        dispatch(updateAllOtherSourceNotes({ applicantId: data?.candidateId, newNoteUiid: data?.uiid,uiid:data.uiid,note: data?.note,addedBy: data?.addedBy,addedOn: data?.addedOn }))
        if (source == "AllApplicants") {
          dispatch(updateApplicantNotes({ applicantId: data?.candidateId, newNoteUiid: data?.uiid,uiid:data.uiid,note: data?.note,addedBy: data?.addedBy,addedOn: data?.addedOn }))
          dispatch(
            updateApplicantWithNotes({
              applicantId: data?.candidateId,
              uiid: data?.uiid,
              note: data?.note,
              addedBy: data?.addedBy,
              addedOn: data?.addedOn
            })
          );
        }
        setNotesRefreshKey(prev => prev + 1);
        if (notesTabIndex !== -1) {
          setActiveTab(notesTabIndex);
        }
        // callApi = true
      }
    } catch (error) {
      showToast("Error adding notes.", "error", 2000);
      console.error("Error adding notes:", error);
    }

    ////dispatching for only AllApplicants page
    // if (source == "AllApplicants" && callApi) {
    //   callApi = false
    //   dispatch(
    //     fetchAllApplicantsStart({
    //       coll: "Candidate",
    //       lim: limit || 25,
    //       pg: page || 1,
    //       ref: "Resume Submission",
    //       extret: "uiid firstName",
    //       sort: JSON.stringify({ uiid: -1 }),
    //     })
    //   );
    // }
  };

  return (
    <div>
      <Drawer
        isOpen={isOpen}
        onClose={handleClose}
        width="xl:w-2xl 2xl:w-5xl lg:w-4xl md:w-2xl sm:w-2xl"
        title="  "
      >
        <div className="shadow-md !bg-[#fffcfa] rounded-lg p-3 mx-3 my-1">
          <PageHeader
            Section={
              <div className="flex items-center gap-4">
                <div className="flex flex-col items-start">
                  <div className="text-primary mb-0.5">
                    {applicantIdForNav ? (
                      <Link
                        to="/ats/applicants/applicant-details"
                        state={{
                          applicantId: applicantIdForNav
                        }}
                        className="cursor-pointer"
                      >
                        <PageTitle
                          // title={
                          //   // getCurrentApplicantPersonalDetails()["First Name"] +
                          //   // " " +
                          //   // getCurrentApplicantPersonalDetails()["Last Name"]
                          //   "New Name"
                          // }
                          title={
                            formatWords2(applicantData || filteredApplicantData
                              ? applicantData?.applicantName ||
                              filteredApplicantData?.name ||
                              [
                                applicantData?.firstName,
                                applicantData?.middleName,
                                applicantData?.lastName,
                              ]
                                .filter(Boolean) // removes undefined, null, "", etc.
                                .join(" ") ||
                              "-"
                              : "-")
                          }
                          tag="h6"
                        />
                      </Link>
                    ) : (
                      <PageTitle
                        // title={
                        //   // getCurrentApplicantPersonalDetails()["First Name"] +
                        //   // " " +
                        //   // getCurrentApplicantPersonalDetails()["Last Name"]
                        //   "New Name"
                        // }
                        title={
                          formatWords2(applicantData || filteredApplicantData
                            ? applicantData?.applicantName ||
                            filteredApplicantData?.name ||
                            [
                              applicantData?.firstName,
                              applicantData?.middleName,
                              applicantData?.lastName,
                            ]
                              .filter(Boolean) // removes undefined, null, "", etc.
                              .join(" ") ||
                            "-"
                            : "-")
                        }
                        tag="h6"
                      />
                    )}
                  </div>
                  <div className="text-gray-400 font-[500] text-xs">
                    <PageTitle
                      // title={
                      //   "New Role"
                      //   // getCurrentApplicantJobTitle()
                      // }
                      title={
                        formatWords2(applicantData || filteredApplicantData
                          ? applicantData?.jobTitle ||
                          filteredApplicantData?.jobTitle
                          : "-")
                      }
                      tag="p"
                    />
                  </div>
                </div>
                <StatusTags icon />
              </div>
            }
            RightSection={
              <div className="flex item-center gap-3">
                <SmartTooltip
                  description={"Call"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    disabled={applicantData ? false : true}
                    icon={"phone"}
                    variant="text"
                    size="sm"
                  />
                </SmartTooltip>
                <SmartTooltip
                  description={"Download"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    disabled={resumeLink ? false : true}
                    onClick={getCandidateResume}
                    icon={"vertical_align_bottom"}
                    variant="text"
                    size="sm"
                  />
                </SmartTooltip>
                <Link
                  to={`/resumeviewerapplicant/${applicantData?.uiid ?? ""}?keywords=${encodeURIComponent(JSON.stringify(keywords ?? []))}`}
                  target="_blank"
                  // onClick={() => {
                  //   localStorage.setItem(
                  //     "applicantId",
                  //     JSON.stringify(applicantData?.uiid ?? "")
                  //   );
                  //   localStorage.setItem(
                  //     "keywords",
                  //     JSON.stringify(keywords ?? [])
                  //   );
                  // }}
                  rel="noopener noreferrer"
                  className="text-info-400 flex items-center gap-.5"
                >
                  <SmartTooltip
                    description={"Open New Tab"}
                    tooltipPosition={"bottom"}
                    noicon
                  >
                    <Button
                      color="black"
                      type="icon"
                      disabled={applicantData ? false : true}
                      icon={"open_in_new"}
                      variant="text"
                      size="sm"
                    />
                  </SmartTooltip>
                </Link>
                <SmartTooltip
                  description={"View Resume"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    onClick={async () => {
                      setViewModal(true);
                      await viewResume();
                    }}
                    icon={"visibility"}
                    disabled={resumeLink ? false : true}
                    variant="text"
                    size="sm"
                  />
                </SmartTooltip>
                <SmartTooltip
                  description={"Email"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    icon={"mail"}
                    disabled={applicantData ? false : true}
                    variant="text"
                    size="sm"
                    onClick={() => setEmailModal(true)}
                  />
                </SmartTooltip>
                <SmartTooltip
                  description={"Note"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  {applicantData && (
                    <DualIcon
                      iconColor={"black"}
                      badgeIconColor="bg-black"
                      size="xs"
                      // onClick={() => setNotesModal(true)}
                      onClick={() => {
                        if (notesTabIndex !== -1) {
                          setActiveTab(notesTabIndex); // changed as per chandan sir discussion 13-01-2026
                          setNotesModal(true) 
                        }
                      }}
                    />
                  )}
                </SmartTooltip>
                <SmartTooltip
                  description={"Submit Job"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  {applicantData && (
                    <DualIcon
                      size="xs"
                      icon="article"
                      badgeIcon="visibility"
                      iconColor="black"
                      dotPosition="bottom-right"
                      badgeIconColor="text-black"
                      onClick={() => setSubmitJobModal(true)}
                    />
                  )}
                </SmartTooltip>
              </div>
            }
          // RightSection={Array.from({ length: 11 }, (_, i) => (
          //   <span className="material-symbols-outlined mr-3">
          //     vertical_align_bottom
          //   </span>
          // ))}
          />

          <div className="px-8 inner-section shadow-xl rounded-lg py-5 flex my-3">
            <div className="flex flex-1 w-full">
              <AdvSeparator gap="gap-6" className="gap-y-6 overflow-hidden">
                {Object.keys(
                  data
                  //   getCurrentApplicantContactDetailsForHeader(source)
                ).map((key, index) => {
                  return (
                    <>
                      <InfoTextAdv
                        key={index}
                        title={key}
                        titleProps={{ className: "!text-black" }}
                        value={
                          <div className="w-full">
                            <div className=" text-black font-medium">
                              {key === "Email" ? (
                                <div className={"flex items-center gap-0.5 "}>
                                  <h6 className="line-clamp-1">
                                    {
                                      //   getCurrentApplicantContactDetailsForHeader(
                                      //     source
                                      //   )[key]
                                      data[key]
                                    }
                                  </h6>
                                  <CopyToClipboard
                                    content={
                                      //   getCurrentApplicantContactDetailsForHeader(
                                      //     source
                                      //   )[key]
                                      data[key]
                                    }
                                    title={data[key]}
                                  />
                                </div>
                              ) : (
                                // <h6 className="line-clamp-1">
                                //   {
                                //     // getCurrentApplicantContactDetailsForHeader(
                                //     //   source
                                //     // )[key]
                                //     data[key]
                                //   }
                                // </h6>
                                <h6
  className={
    key === "Mobile"
      ? "whitespace-nowrap overflow-hidden text-ellipsis"
      : "line-clamp-1"
  }
>
  {data[key]}
</h6>
                              )}
                            </div>
                          </div>
                        }
                      />
                    </>
                  );
                })}
              </AdvSeparator>
            </div>
          </div>
        </div>
        <div className="flex-1 flex flex-col  h-full">
          <NewTab
            tabs={viewMenus}
            color="gray"
            variant="text"
            activeVariant="text"
            onTabChange={(index) => setActiveTab(index)}
            defaultTab={activeTab}
            key={activeTab}
          />
        </div>
        <Backdrop isOpen={loading} zIndex={53}>
          <LogoLoader />
        </Backdrop>
      </Drawer>
      <ApplicantEmailModal
        isOpen={emailModal}
        onClose={() => setEmailModal(false)}
      />
      <ApplicantNotesModal
        value={notes}
        onChange={(e) => {
          const val = e?.target?.value ?? e;
          setCandidateNotes(val);
        }}
        onClick={async (jobPost, priority) => {
          await handleAddNotes(jobPost, priority);
        }}
        isOpen={notesModal}
        onClose={() => {
          setNotesModal(false);
          setCandidateNotes("");
        }}
      />
      <ApplicantSubmitJobModal
        isOpen={submitJobModal}
        onClose={() => setSubmitJobModal(false)}
        applicant={applicantData}
      />
      <Modal
        width="max-w-6xl"
        title={formatWords2(resumeName || "Resume Details")}
        isOpen={viewModal}
        onClose={() => {setViewModal(false); setAwsUrl(""); setAwsHtmlResume("")}}
      >
        <DocumentViewerATS AwsResumeUrl={awsUrl || ""} urlLoading={awsurlloading} htmlFormat={hasContent(awsHtmlResume) ? awsHtmlResume : htmlFormat} />
      </Modal>
    </div>
  );
};

export default ApplicantsDetailsDrawer;
